import { Vue, prop } from 'vue-class-component';
import { Watch, Inject } from 'vue-property-decorator';
import { WidgetWrapper } from '@/components/widget-wrapper';
import { TileSelector } from '@/components/tile-selector';
import { DealType, IncentiveObject } from '@/types/writeup';
import type { VueI18n } from 'vue-i18n';
import styles from './styles.module.scss';

class IncentivesSelectorProps {
	type = prop<DealType>({ default: undefined })

	active = prop<number>({ default: undefined })

	loading = prop<boolean>({ default: true })

	onChange = prop<Function>({ default: () => () => undefined })

	incentives = prop<IncentiveObject[]>({ default: [] })
}

export class IncentivesSelector extends Vue.with(IncentivesSelectorProps) {
	@Inject() readonly i18n!: VueI18n;

	activeIncentive = this.active === undefined ? null : this.active;

	@Watch('active')
	updateActive() {
		this.activeIncentive = this.active;
	}

	get tiles() {
		return this.incentives.map((incentive, index) => ({
			id: String(index),
			title: (this.type === 'lease')
				? this.i18n.t('incentivesSelector.leasingFor', { miles: incentive.terms[0].miles, months: incentive.terms[0].months })
				: this.i18n.t('incentivesSelector.financingFor', { apr: incentive.terms[0].apr, months: incentive.terms[0].months }),
			description: incentive.name,
		}));
	}

	onIncentiveChange(id: string) {
		const incentive = this.incentives[+id];

		this.activeIncentive = +id;
		this.onChange({
			id: incentive.id,
			term: {
				apr: incentive.terms[0].apr,
				months: incentive.terms[0].months,
				miles: incentive.terms[0].miles,
			},
		});
	}

	render() {
		return (
			<WidgetWrapper
				title={ this.type ? this.i18n.t('incentivesSelector.title', { type: this.type }) : undefined }
				active={ this.activeIncentive !== null || this.loading }
				loading={ this.loading }
				class={ styles.incentivesSelector }
			>
				<TileSelector
					tiles={ this.tiles }
					active={ this.activeIncentive === null ? undefined : String(this.activeIncentive) }
					onChange={ this.onIncentiveChange }
					fullWidth
				/>
			</WidgetWrapper>
		);
	}
}
